import { useRouter } from 'next/router'
import { UserProfileTabBar as View } from 'ui-components'
import { useIsMyProfile } from '~user-profile/hooks/useIsMyProfile'
import { useGetCurrentUserCache } from '~user-profile/queries/useGetUserById'
import { useSearchMapsInCurrentUserProfileCache } from '~user-profile/queries/useSearchMaps'

const TabBar = () => {
  const router = useRouter()

  const isMyProfile = useIsMyProfile()

  const { isLoading: isMapsLoading, data: searchMapsData } =
    useSearchMapsInCurrentUserProfileCache()

  const { isLoading: isProfileLoading, data: user } = useGetCurrentUserCache()

  const handleTabChange = (_, nextTab) => {
    router.push({
      query: {
        userId: router.query.userId,
        username: router.query.username,
        tab: nextTab
      }
    })
  }

  return (
    <View
      canUpdateUserSettings={isMyProfile}
      totalMaps={searchMapsData?.total || 0}
      totalWorkspaces={user?.membershipCollection?.total || 0}
      loading={isProfileLoading || isMapsLoading}
      currentTab={router.query.tab}
      onTabChange={handleTabChange}
    />
  )
}

export { TabBar }
